import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Select } from 'antd';

import type { MessengerModalFormValues } from '@pages/Integrations/IntegrationsList/types';

import type { DefaultOptionType } from 'antd/es/select';
import type { FC } from 'react';

const { List, Item, useFormInstance, useWatch } = Form;

interface Props {
  operators: DefaultOptionType[];
  isLoading: boolean;
}

export const OperatorsBlock: FC<Props> = ({ operators, isLoading }) => {
  const form = useFormInstance<MessengerModalFormValues>();
  const selectedOperatorsIds = useWatch('operators', form);

  return (
    <div className="operators-block">
      <List name="operators">
        {(fields, { add, remove }) => (
          <>
            <div className="operators-list">
              {fields.map(({ key, ...restField }) => {
                const fieldIndex = restField.name;
                const currentValue =
                  form.getFieldValue('operators')?.[fieldIndex];

                const filteredOptions = operators.filter(
                  ({ value }) =>
                    currentValue === value ||
                    !(selectedOperatorsIds || []).includes(value as number)
                );

                return (
                  <div className="operator-row" key={key}>
                    <Item
                      {...restField}
                      name={[fieldIndex]}
                      className="operator-select"
                    >
                      <Select
                        placeholder="Выберите оператора"
                        showSearch
                        optionFilterProp="label"
                        options={filteredOptions}
                      />
                    </Item>
                    <Item noStyle>
                      <Button
                        className="operator-delete"
                        icon={<DeleteOutlined />}
                        onClick={() => remove(fieldIndex)}
                      />
                    </Item>
                  </div>
                );
              })}
            </div>
            <Item>
              <Button
                type="primary"
                onClick={() => add()}
                disabled={isLoading}
                icon={<PlusOutlined />}
                block
              >
                Добавить оператора
              </Button>
            </Item>
          </>
        )}
      </List>
    </div>
  );
};
